import React from "react"

import { EinInput } from "../../Input"


const renderEinInput = (itemProps, inputProps, form, path) => {
  return (
    <EinInput
      form={form}
      itemProps={itemProps}
      inputProps={inputProps}
      path={path}
    />
  )
}

export default renderEinInput
